<script>
import HireflyLogo from '@/assets/icons/hirefly-logo.svg';
import Typography from '@/components/v3/base/Typography';
import DropdownMenu from '@/components/v3/base/DropdownMenu';
import menuIcon from '@/assets/icons/menu-icon-white.svg';
import Button from '@/components/v3/base/Button';

export default {
  components: {
    Typography,
    DropdownMenu,
    Button,
  },

  data() {
    return {
      isOpen: false,
      products: [
        {
          text: 'Hirefly Autopilot',
          link: '/autopilot',
        },
        {
          text: 'Hirefly FastTrack',
          link: '/fast-track',
        },
      ],

      menuIcon,
      HireflyLogo,
      sectionActive: [],
    };
  },

  mounted() {
    this.onScroll();
    const session = localStorage.getItem('session');
    if (session) {
      this.$router.push('/panel');
    }
    window.addEventListener('scroll', this.onScroll, true);
  },

  unmounted() {
    window.removeEventListener('scroll', this.onScroll, true);
  },

  methods: {
    onOpenMenu() {
      this.isOpen = !this.isOpen;
    },

    onScroll() {
      const scrollY = window.scrollY;
      const section1 = document.getElementById('footer-section') ?? {};

      const section1Top = section1.offsetTop;
      const section1Height = section1.offsetHeight;
      const section1Bottom = section1Top + section1Height;

      const checkPoint = scrollY + window.innerHeight;

      if (checkPoint >= section1Top && scrollY <= section1Bottom) {
        this.sectionActive.push(1);
      }
    },
  },
};
</script>
<!-- eslint-disable vue/no-undef-components -->
<template>
  <div>
    <div class="tw-sticky tw-top-0 tw-bg-purple-500 tw-z-50 tw-px-6">
      <div
        class="tw-max-w-container-1 tw-mx-auto md:tw-flex tw-justify-between tw-items-center tw-py-4"
      >
        <div>
          <router-link to="/">
            <img :src="HireflyLogo" alt="Hirefly.ai" />
          </router-link>
        </div>
        <div>
          <div class="tw-w-12 md:tw-hidden tw-absolute tw-top-4 tw-right-0">
            <div class="tw-cursor-pointer" @click="onOpenMenu">
              <img :src="menuIcon" alt="menu" />
            </div>
          </div>
          <Typography
            variant="subtitle-2"
            class="md:tw-flex tw-items-center tw-gap-6 tw-pt-6 md:tw-pt-0 main-menu"
            :class="{ 'tw-grid': isOpen, 'tw-hidden': !isOpen }"
          >
            <DropdownMenu
              :options="products"
              title="Products"
              :minWidth="200"
              class="custom-menu"
            />
            <a
              href="/about"
              class="tw-text-white hover:tw-text-gray-300 !tw-no-underline"
            >
              About
            </a>
            <a
              href="https://hirefly.freshteam.com/jobs"
              target="_blank"
              class="tw-text-white hover:tw-text-gray-300 !tw-no-underline"
            >
              Careers
            </a>
            <div
              class="tw-border-0 tw-border-l-2 tw-border-white tw-border-solid tw-h-[20px] tw-hidden md:tw-block"
            ></div>
            <a
              href="/login"
              class="tw-text-white hover:tw-text-gray-300 !tw-no-underline"
            >
              Sign in
            </a>
            <a href="/contact">
              <div>
                <Button size="small" variant="white">Book a demo</Button>
              </div>
            </a>
          </Typography>
        </div>
      </div>
    </div>
    <div class="tw-text-gray-900">
      <router-view></router-view>
    </div>
    <div id="footer-section" class="tw-bg-purple-500 tw-py-12 tw-px-6">
      <div
        class="tw-max-w-container-1 tw-mx-auto md:tw-flex tw-justify-between tw-items-start tw-py-4 tw-translate-y-0 tw-transition-all tw-duration-700 tw-delay-200"
        :class="{
          '-tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
            !sectionActive.includes(1),
        }"
      >
        <div class="tw-pb-6 md:tw-pb-0 tw-w-full">
          <router-link to="/">
            <img :src="HireflyLogo" alt="Hirefly.ai" class="tw-h-8" />
          </router-link>
        </div>
        <Typography
          variant="body-2"
          class="tw-flex tw-gap-8 tw-items-start tw-text-white tw-w-full"
        >
          <div class="tw-grid tw-gap-2 tw-w-full">
            <Typography variant="subtitle-1" class="tw-pb-4"
              >Company</Typography
            >
            <a href="/about" class="!tw-text-white">About</a>
            <a
              href="https://hirefly.freshteam.com/jobs"
              target="_blank"
              class="!tw-text-white"
              >Careers</a
            >
          </div>
          <div class="tw-grid tw-gap-2 tw-w-full">
            <Typography variant="subtitle-1" class="tw-pb-4"
              >Products</Typography
            >
            <a
              v-for="(item, i) in products"
              :key="i"
              :href="item.link"
              class="!tw-text-white"
            >
              {{ item.text }}
            </a>
          </div>
          <div class="tw-grid tw-gap-2 tw-w-full">
            <Typography variant="subtitle-1" class="tw-pb-4">Legal</Typography>
            <router-link to="/privacy" class="!tw-text-white">
              Privacy policy
            </router-link>
            <router-link to="/terms-of-service" class="!tw-text-white">
              Terms of service
            </router-link>
          </div>
        </Typography>
      </div>
    </div>
  </div>
</template>
